module.exports = __webpack_public_path__ + "img/bus-school.9d126626.svg";